<template>
  <div class="idcard-list-container">
    <div class="mt-2" style="text-align: left;margin-left: 30px;">
      <h6 class="p-2" style="color:grey; font-size: 0.9rem;">
        {{ $t("select-persons-for-staticCard") }}
      </h6>
    </div>

    <div style="display: flex;">
      <!-- Organisationsliste -->
      <div class="mt-2" style="margin-right:100px; margin-left:40px;">
        <vs-input
          class="search-input org-width"
          icon-after="search"
          :placeholder="$t('organization-search')"
          v-model="organization_search"
          icon="search"
          icon-no-border
        />

        <div class="outer-con3">
          <div class="table-container2">
            <table>
              <thead>
                <tr>
                  <th @click="sort('name')">
                    {{ $t("organization") }}
                    <div
                      class="arrow"
                      v-if="'name' === currentSort"
                      v-bind:class="ascending ? 'arrow_up' : 'arrow_down'"
                    ></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="cursor"
                  v-for="organization in organizations"
                  :key="organization.id"
                  @click="selectOrganization(organization)"
                >
                  <td
                    :class="{ active: isActiveOrganization(organization.id) }"
                  >
                    {{ organization.name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Ausweise der Organisation -->
      <div
        v-if="selectedOrganization"
        class="table-container2"
        style="padding-left:100px; margin-top:6px; border-left:1px solid #CCCCCC;"
      >
        <div style="display: flex; gap: 10px; align-items: center;">
          <vs-input
            class="search-input2"
            style="padding-bottom:2px"
            icon-after="search"
            :placeholder="$t('name-search')"
            v-model="person_search"
            icon="search"
            icon-no-border
          />

          <!-- Status-Filter Dropdown -->
          <vs-select
            v-model="status_filter"
            placeholder="Status wählen"
            style="width: 150px;margin-bottom: 30px;"
          >
            <vs-select-item value="" text="Alle" />
            <vs-select-item value="open" text="Offen" />
            <vs-select-item value="approved" text="Genehmigt" />
            <vs-select-item value="active" text="Aktiv" />
            <vs-select-item value="deactivated" text="Gesperrt" />
            <vs-select-item value="expired" text="Abgelaufen" />
            <vs-select-item value="error" text="Fehler" />
          </vs-select>
        </div>

        <div class="outer-con3" style="margin-top: 5px;">
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    v-model="selectAll"
                    @change="selectAllItems"
                  />
                </th>
                <th @click="sortA('person_last_name')">
                  {{ $t("Name") }}
                </th>
                <th @click="sortA('person_first_name')">
                  {{ $t("Vorname") }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="idCard in idCardsByOrganization"
                :key="idCard.id"
                class="cursor"
              >
                <td>
                  <input
                    type="checkbox"
                    :checked="isInSelectedIdCards(idCard)"
                    @change="toggleIdCard(idCard)"
                  />
                </td>
                <td>{{ idCard.person_last_name }}</td>
                <td>{{ idCard.person_first_name }}</td>
              </tr>

              <tr v-if="idCardsByOrganization.length === 0">
                <td colspan="4">
                  {{ "Keine Ausweise vorhanden" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Aktionen -->
        <div style="display: flex; justify-content: flex-end; margin-top: 5px;">
          <div
            v-if="
              selectedOrganization && (selectedPersons.length > 0 || selectAll)
            "
            style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-top: 25px;
                    margin-left: 50px;
                  "
          >
            <span>Extrafelder anzeigen </span
            ><vs-switch v-model="includeExtraField"></vs-switch>
          </div>
          <div
            v-if="
              selectedOrganization && (selectedPersons.length > 0 || selectAll)
            "
            style="margin-left: 50px; margin-top: 40px;"
          >
            <vs-button
              @click="generatePDF()"
              class="generate-pdf-button"
              icon="download"
            >
              {{ $t("generate-pdf") }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "StaticIdCardList",

  data() {
    return {
      selectedOrganization: null,
      organization_search: "",
      person_search: "",
      currentSort: "name",
      currentSortA: "person_last_name",
      currentSortDir: "asc",
      currentSortDirA: "asc",
      ascending: false,
      ascendingA: false,
      selectAll: false,
      selectedPersons: [],
      includeExtraField: false,
      status_filter: "",
    };
  },

  computed: {
    availableStatuses() {
      return [...new Set(this.idCardsByOrganization.map((c) => c.status))];
    },
    organizations() {
      let list = this.$store.getters["organization/getOrganizations"] || [];

      if (this.organization_search) {
        list = list.filter((o) =>
          o.name.toLowerCase().includes(this.organization_search.toLowerCase()),
        );
      }

      return this.sortList(list, this.currentSort, this.currentSortDir);
    },

    idCardsByOrganization() {
      if (!this.selectedOrganization) return [];

      let list = this.$store.getters["idCard/getIdCards"].filter(
        (c) => c.organisation_id === this.selectedOrganization.id,
      );

      // Name filter
      if (this.person_search) {
        list = list.filter((c) =>
          `${c.person_first_name} ${c.person_last_name}`
            .toLowerCase()
            .includes(this.person_search.toLowerCase()),
        );
      }

      // Status filter
      if (this.status_filter) {
        list = list.filter((c) => c.status === this.status_filter);
      }

      return this.sortList(list, this.currentSortA, this.currentSortDirA);
    },
  },

  methods: {
    getDefaultDate() {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      return d.toISOString().slice(0, 10);
    },

    sortList(list, key, dir) {
      const mod = dir === "desc" ? -1 : 1;
      return [...list].sort((a, b) =>
        a[key] < b[key] ? -mod : a[key] > b[key] ? mod : 0,
      );
    },

    selectOrganization(org) {
      this.selectedPersons = [];
      this.selectAll = false;
      this.selectedOrganization = org;

      this.$store.dispatch("organization/loadOrganization", org.id);
      this.$store.dispatch("idCard/loadIdCards", {
        organisation_id: org.id,
      });
    },

    toggleIdCard(idCard) {
      if (this.isInSelectedIdCards(idCard)) {
        this.selectedPersons = this.selectedPersons.filter(
          (p) => p.id !== idCard.id,
        );
      } else {
        this.selectedPersons.push(idCard);
      }
    },

    isInSelectedIdCards(idCard) {
      return this.selectedPersons.some((p) => p.id === idCard.id);
    },

    isActiveOrganization(id) {
      return this.selectedOrganization?.id === id;
    },

    selectAllItems() {
      this.selectedPersons = this.selectAll
        ? [...this.idCardsByOrganization]
        : [];
    },

    sort(field) {
      this.currentSortDir =
        this.currentSort === field && this.currentSortDir === "asc"
          ? "desc"
          : "asc";
      this.currentSort = field;
      this.ascending = !this.ascending;
    },

    sortA(field) {
      this.currentSortDirA =
        this.currentSortA === field && this.currentSortDirA === "asc"
          ? "desc"
          : "asc";
      this.currentSortA = field;
      this.ascendingA = !this.ascendingA;
    },

    async generatePDF() {
      await this.$store.dispatch("organization/loadStaticIdCard", {
        id: this.selectedOrganization.id,
        list: this.selectedPersons.map((p) => p.person_id),
        includeExtraField: this.includeExtraField,
      });
    },
  },
  watch: {
    person_search() {
      this.selectAll = false;
      this.selectedPersons = [];
    },
    status_filter() {
      this.selectAll = false;
      this.selectedPersons = [];
    },
  },
});
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
.active {
  background-color: #f0f0f0;
}
</style>
